import { Reducer } from "redux";

import { AuthNotificationsDownloadResponse } from "../models/api/Referral";
import { AuthNotificationsDownloadActionDispatchTypes } from "../constants/HomePage";
import { AuthNotificationsDownloadDispatchTypes } from "../models/dispatchTypes/Referral";

const initialState: AuthNotificationsDownloadResponse = {
  loading: false,
  response: null,
  error: null,
};

const AuthNotificationsDownloadReducer: Reducer<
  AuthNotificationsDownloadResponse,
  AuthNotificationsDownloadDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case AuthNotificationsDownloadActionDispatchTypes.GET_AUTH_NOTIFICATIONS_DOWNLOAD_INVOKE: {
      return {
        ...state,
        response: null,
        loading: true,
        error: null,
      };
    }
    case AuthNotificationsDownloadActionDispatchTypes.GET_AUTH_NOTIFICATIONS_DOWNLOAD_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: null,
      };
    }
    case AuthNotificationsDownloadActionDispatchTypes.GET_AUTH_NOTIFICATIONS_DOWNLOAD_ERROR: {
      return {
        ...state,
        error: action.error,
        response: null,
        loading: false,
      };
    }
  }
  return state;
};

export default AuthNotificationsDownloadReducer;